/**
 * Catálogo de tribunais atendidos pela API Pública do DataJud.
 *
 * Os pares (segmento, código do tribunal) foram conferidos contra dados reais:
 * para cada alias abaixo foram lidos documentos da própria API e extraídos os
 * dígitos `J` e `TR` do campo `numeroProcesso`. Ver README, seção "Como o
 * tribunal é descoberto".
 */
/** Segmento do Judiciário — o 14º dígito do número CNJ. */
export const Segmento = {
    STF: "1",
    CNJ: "2",
    STJ: "3",
    JUSTICA_FEDERAL: "4",
    JUSTICA_DO_TRABALHO: "5",
    JUSTICA_ELEITORAL: "6",
    JUSTICA_MILITAR_UNIAO: "7",
    JUSTICA_ESTADUAL: "8",
    JUSTICA_MILITAR_ESTADUAL: "9",
};
const t = (alias, sigla, nome, justica, segmento, codigo) => ({ alias, sigla, nome, justica, segmento, codigo });
const SUPERIORES = "Tribunais Superiores";
const ESTADUAL = "Justiça Estadual";
const FEDERAL = "Justiça Federal";
const TRABALHO = "Justiça do Trabalho";
const ELEITORAL = "Justiça Eleitoral";
const MILITAR_ESTADUAL = "Justiça Militar Estadual";
export const TRIBUNAIS = [
    t("stj", "STJ", "Superior Tribunal de Justiça", SUPERIORES, Segmento.STJ, null),
    t("stm", "STM", "Superior Tribunal Militar", SUPERIORES, Segmento.JUSTICA_MILITAR_UNIAO, null),
    t("tst", "TST", "Tribunal Superior do Trabalho", SUPERIORES, Segmento.JUSTICA_DO_TRABALHO, null),
    t("tse", "TSE", "Tribunal Superior Eleitoral", SUPERIORES, Segmento.JUSTICA_ELEITORAL, null),
    t("trf1", "TRF1", "Tribunal Regional Federal da 1ª Região", FEDERAL, Segmento.JUSTICA_FEDERAL, "01"),
    t("trf2", "TRF2", "Tribunal Regional Federal da 2ª Região", FEDERAL, Segmento.JUSTICA_FEDERAL, "02"),
    t("trf3", "TRF3", "Tribunal Regional Federal da 3ª Região", FEDERAL, Segmento.JUSTICA_FEDERAL, "03"),
    t("trf4", "TRF4", "Tribunal Regional Federal da 4ª Região", FEDERAL, Segmento.JUSTICA_FEDERAL, "04"),
    t("trf5", "TRF5", "Tribunal Regional Federal da 5ª Região", FEDERAL, Segmento.JUSTICA_FEDERAL, "05"),
    // O TRF6 foi desmembrado do TRF1 e reaproveita o código 01 no número do processo.
    t("trf6", "TRF6", "Tribunal Regional Federal da 6ª Região", FEDERAL, Segmento.JUSTICA_FEDERAL, "01"),
    t("tjac", "TJAC", "Tribunal de Justiça do Acre", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "01"),
    t("tjal", "TJAL", "Tribunal de Justiça de Alagoas", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "02"),
    t("tjap", "TJAP", "Tribunal de Justiça do Amapá", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "03"),
    t("tjam", "TJAM", "Tribunal de Justiça do Amazonas", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "04"),
    t("tjba", "TJBA", "Tribunal de Justiça da Bahia", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "05"),
    t("tjce", "TJCE", "Tribunal de Justiça do Ceará", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "06"),
    t("tjdft", "TJDFT", "Tribunal de Justiça do Distrito Federal e Territórios", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "07"),
    t("tjes", "TJES", "Tribunal de Justiça do Espírito Santo", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "08"),
    t("tjgo", "TJGO", "Tribunal de Justiça de Goiás", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "09"),
    t("tjma", "TJMA", "Tribunal de Justiça do Maranhão", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "10"),
    t("tjmt", "TJMT", "Tribunal de Justiça de Mato Grosso", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "11"),
    t("tjms", "TJMS", "Tribunal de Justiça de Mato Grosso do Sul", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "12"),
    t("tjmg", "TJMG", "Tribunal de Justiça de Minas Gerais", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "13"),
    t("tjpa", "TJPA", "Tribunal de Justiça do Pará", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "14"),
    t("tjpb", "TJPB", "Tribunal de Justiça da Paraíba", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "15"),
    t("tjpr", "TJPR", "Tribunal de Justiça do Paraná", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "16"),
    t("tjpe", "TJPE", "Tribunal de Justiça de Pernambuco", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "17"),
    t("tjpi", "TJPI", "Tribunal de Justiça do Piauí", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "18"),
    t("tjrj", "TJRJ", "Tribunal de Justiça do Rio de Janeiro", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "19"),
    t("tjrn", "TJRN", "Tribunal de Justiça do Rio Grande do Norte", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "20"),
    t("tjrs", "TJRS", "Tribunal de Justiça do Rio Grande do Sul", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "21"),
    t("tjro", "TJRO", "Tribunal de Justiça de Rondônia", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "22"),
    t("tjrr", "TJRR", "Tribunal de Justiça de Roraima", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "23"),
    t("tjsc", "TJSC", "Tribunal de Justiça de Santa Catarina", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "24"),
    t("tjse", "TJSE", "Tribunal de Justiça de Sergipe", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "25"),
    t("tjsp", "TJSP", "Tribunal de Justiça de São Paulo", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "26"),
    t("tjto", "TJTO", "Tribunal de Justiça do Tocantins", ESTADUAL, Segmento.JUSTICA_ESTADUAL, "27"),
    t("tjmmg", "TJMMG", "Tribunal de Justiça Militar de Minas Gerais", MILITAR_ESTADUAL, Segmento.JUSTICA_MILITAR_ESTADUAL, "13"),
    t("tjmrs", "TJMRS", "Tribunal de Justiça Militar do Rio Grande do Sul", MILITAR_ESTADUAL, Segmento.JUSTICA_MILITAR_ESTADUAL, "21"),
    t("tjmsp", "TJMSP", "Tribunal de Justiça Militar de São Paulo", MILITAR_ESTADUAL, Segmento.JUSTICA_MILITAR_ESTADUAL, "26"),
    ...Array.from({ length: 24 }, (_, i) => {
        const n = i + 1;
        return t(`trt${n}`, `TRT${n}`, `Tribunal Regional do Trabalho da ${n}ª Região`, TRABALHO, Segmento.JUSTICA_DO_TRABALHO, String(n).padStart(2, "0"));
    }),
    ...[
        ["ac", "Acre", "01"], ["al", "Alagoas", "02"], ["ap", "Amapá", "03"],
        ["am", "Amazonas", "04"], ["ba", "Bahia", "05"], ["ce", "Ceará", "06"],
        ["df", "Distrito Federal", "07"], ["es", "Espírito Santo", "08"], ["go", "Goiás", "09"],
        ["ma", "Maranhão", "10"], ["mt", "Mato Grosso", "11"], ["ms", "Mato Grosso do Sul", "12"],
        ["mg", "Minas Gerais", "13"], ["pa", "Pará", "14"], ["pb", "Paraíba", "15"],
        ["pr", "Paraná", "16"], ["pe", "Pernambuco", "17"], ["pi", "Piauí", "18"],
        ["rj", "Rio de Janeiro", "19"], ["rn", "Rio Grande do Norte", "20"], ["rs", "Rio Grande do Sul", "21"],
        ["ro", "Rondônia", "22"], ["rr", "Roraima", "23"], ["sc", "Santa Catarina", "24"],
        ["se", "Sergipe", "25"], ["sp", "São Paulo", "26"], ["to", "Tocantins", "27"],
    ].map(([uf, estado, codigo]) => 
    // Atenção: a wiki do CNJ lista o alias do TRE do DF como `tre-dft`, mas esse
    // caminho responde 404. O alias que funciona é `tre-df`.
    t(`tre-${uf}`, `TRE-${uf.toUpperCase()}`, `Tribunal Regional Eleitoral - ${estado}`, ELEITORAL, Segmento.JUSTICA_ELEITORAL, codigo)),
];
const POR_ALIAS = new Map(TRIBUNAIS.map((trib) => [trib.alias, trib]));
const POR_SIGLA = new Map(TRIBUNAIS.map((trib) => [trib.sigla.toUpperCase(), trib]));
const POR_SEGMENTO_CODIGO = new Map();
for (const trib of TRIBUNAIS) {
    if (trib.codigo === null)
        continue;
    const chave = `${trib.segmento}${trib.codigo}`;
    const lista = POR_SEGMENTO_CODIGO.get(chave);
    if (lista)
        lista.push(trib);
    else
        POR_SEGMENTO_CODIGO.set(chave, [trib]);
}
export function tribunalPorAlias(alias) {
    return POR_ALIAS.get(alias.trim().toLowerCase());
}
/** Aceita tanto a sigla (`TJSP`) quanto o alias (`tjsp`). */
export function tribunalPorSigla(sigla) {
    const chave = sigla.trim().toUpperCase();
    return POR_SIGLA.get(chave) ?? POR_ALIAS.get(chave.toLowerCase());
}
/**
 * Tribunais compatíveis com o par (segmento, código) extraído do número CNJ.
 *
 * Devolve mais de um resultado apenas quando o número é ambíguo — o caso do
 * TRF1/TRF6, que dividem o código `4.01`. A ordem é a de tentativa: o tribunal
 * mais antigo (e mais provável) vem primeiro.
 */
export function tribunaisCandidatos(segmento, codigo) {
    return POR_SEGMENTO_CODIGO.get(`${segmento}${codigo}`) ?? [];
}
/** URL de busca da API Pública para o tribunal. */
export function urlDeBusca(tribunal, baseUrl) {
    return `${baseUrl.replace(/\/+$/, "")}/api_publica_${tribunal.alias}/_search`;
}
//# sourceMappingURL=tribunais.js.map